import { createAction } from "redux-actions";
import { CostsConstants } from "./costsConstants";

export const setCosts = createAction(
  CostsConstants.SET_COSTS
);
